import { render, staticRenderFns } from "./callbackmanage.vue?vue&type=template&id=019f07ba&scoped=true&"
import script from "./callbackmanage.vue?vue&type=script&lang=js&"
export * from "./callbackmanage.vue?vue&type=script&lang=js&"
import style0 from "./callbackmanage.vue?vue&type=style&index=0&id=019f07ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019f07ba",
  null
  
)

export default component.exports